import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Alert, Stack, Typography } from '@mui/material';

import { url } from '../../appRouter/url';
import { PageLoading } from '../../components/general/PageLoading';

export const AuthLogoutPage = () => {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();

  if (isAuthenticated) {
    void instance.logoutRedirect();
  }

  return isAuthenticated ? (
    <PageLoading msg="Du wirst ausgeloggt..." />
  ) : (
    <Stack
      justifyContent="center"
      alignContent="center"
      alignItems="center"
      padding={2}
      spacing={2}
      height="100vh"
      maxWidth="500px"
      margin="auto"
    >
      <Alert severity="success" sx={{ width: '100%' }}>
        <Typography variant="paragraphLg" textAlign="center" width="100%">
          Du bist ausgeloggt.
        </Typography>
      </Alert>
      <Typography fontSize={18}>
        {' '}
        Du kannst die Seite schließen oder dich wieder <a href={url.root()}>einloggen</a>.
      </Typography>
    </Stack>
  );
};
